<ul *ngIf="previewElements?.length > 0"
    class="watchlist-preview">
  <li *ngFor="let previewElement of previewElements | slice:0:maxPreviewCount"
      class="watchlist-preview__element">
    <div [ngSwitch]="previewElement.type"
         class="watchlist-preview__element__inner">

      <ng-container *ngSwitchCase="ElementType.Product">
        <img p1Img
             [fileId]="previewElement.imageUuid"
             [title]="previewElement.name || ''"
             [alt]="previewElement.imageAltText || previewElement.name || ''"
             fallback="assets/images/placeholder-image/watchlist/placeholder--small.svg"
             width="48"
             height="48"
             loading="lazy">
      </ng-container>
      <ng-container *ngSwitchCase="ElementType.Supplier">
        <img p1Img
             [fileId]="previewElement.imageUuid"
             [title]="previewElement.name || ''"
             [alt]="previewElement.imageAltText || previewElement.name || ''"
             fallback="assets/images/placeholder-image/watchlist/placeholder-supplier--small.svg"
             width="48"
             height="48"
             loading="lazy">
      </ng-container>
      <ng-container *ngSwitchCase="ElementType.Comparison">
        <img p1Img
             [fileId]="previewElement.imageUuid"
             [title]="previewElement.name || ''"
             [alt]="previewElement.imageAltText || previewElement.name || ''"
             fallback="assets/images/placeholder-image/watchlist/placeholder-comparison--small.svg"
             width="48"
             height="48"
             loading="lazy">
      </ng-container>
      <ng-container *ngSwitchCase="ElementType.Query">
        <img p1Img
             [fileId]="previewElement.imageUuid"
             [title]="previewElement.name || ''"
             [alt]="previewElement.imageAltText || previewElement.name || ''"
             fallback="assets/images/placeholder-image/watchlist/placeholder-productsearch--small.svg"
             width="48"
             height="48"
             loading="lazy">
      </ng-container>
      <ng-container *ngSwitchCase="ElementType.ProductValidation">
        <img p1Img
             [fileId]="previewElement.imageUuid"
             [title]="previewElement.name || ''"
             [alt]="previewElement.imageAltText || previewElement.name || ''"
             fallback="assets/images/placeholder-image/watchlist/placeholder--small.svg"
             width="48"
             height="48"
             loading="lazy">
      </ng-container>
      <ng-container *ngSwitchCase="'Watchlist'">
        <img src="assets/images/placeholder-image/watchlist/placeholder--watchlist.svg"
             [title]="previewElement.name || ''"
             [alt]="previewElement.imageAltText || previewElement.name || ''"
             width="48"
             height="48"
             loading="lazy"/>
      </ng-container>
    </div>
  </li>
  <li *ngIf="previewElements?.length > maxPreviewCount"
      class="watchlist-preview__counter-badge">
    <div>
      +{{ (previewElements?.length - maxPreviewCount) }}
    </div>
  </li>
</ul>

<span *ngIf="previewElements?.length === 0"
      class="watchlist-preview__empty"
      i18n="watchlist preview empty text // page: my watchlists @@watchlist-preview.empty">
  This watchlist is empty. Please add content.
</span>
